<template>
    <v-card class="pa-1 mt-2">
        <Title title="環境BOX情報" dense />
        <v-container fluid class="pa-0">
            <v-row dense v-for="box in boxes" :key="box.master.boxIdentificationCode">
                <v-col style="text-align:center">
                    <v-card class="ma-2" outlined>
                        <h3>{{box.box.name}}</h3>
                        <CurrentValueList :sensors="box.sensors" :readonly="true" />
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <!-- <v-expand-transition>
            <v-card-text class="pa-1">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col v-for="box in boxes" :key="box.master.boxIdentificationCode" cols="12">
                            <v-card flat height="200">
                                <v-card-text class="text-center pa-0">
                                    <h3>{{box.box.name}}</h3>
                                    <CurrentValueList :box="box" :sensors="box.sensors" :readonly="true" />
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-expand-transition> -->
    </v-card>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import CurrentValueList from '@/components/box/SensorCurrentValueList';
    import Title from '@/components/seedling/items/TitleBar'
    export default {
        components: {
            CurrentValueList,
            Title
        },
        data: function () {
            return {
                boxes: []
            }
        },
        computed: {
            /**
             * ユーザーUID(グループユーザーの圃場参照時は、そのユーザーのUID)
             */
            userUID: function () {
                return this.$store.getters["userUID"]
            },
            /**
             * ログインユーザーのUID
             */
            loggedInUserUID: function () {
                return this.$store.getters["loggedInUserUID"]
            },
            /**
             * ログインユーザーデータ
             */
            loggedInUserData: function () {
                return this.$store.getters["loggedInUserData"]
            },
            /** 共有モード */
            shareMode: function () {
                return this.$store.getters["shareMode"]
            },
            /** 共有モードの全種類 */
            shareModeTypes: function () {
                return this.$store.getters["shareModeTypes"]
            },
            /** グループユーザーの圃場管理を参照中は True */
            isShareMode: function () {
                if (this.shareMode == this.shareModeTypes.groupUserWork) {
                    return true
                }
                return false
            },
        },
        created: function () {
            console.log("created")
            const self = this
            this.boxes = []
            db.collection("users").doc(this.userUID).collection("boxes").get().then(function(snapShot) {
                snapShot.forEach(function(doc) {
                    const box = doc.data()
                    db.collection("environments").doc(box.boxIdentificationCode).get().then(function(docMaster) {
                        const master = docMaster.data()
                        const boxData = {
                            box: box,
                            master: master,
                            sensors: []
                        }
                        master.sensors.forEach(function(sensor) {
                            const sensorData = {
                                boxMaster: master,
                                body: sensor,
                                isVisible: false,
                                yAxis: 1,
                                measureInformation: null,
                                alarmHistories: [],
                                chart: null
                            }
                            boxData.sensors.push(sensorData)
                        })
                        self.boxes.push(boxData)
                    }).catch (function (error) {
                        self.mi_writeLog("BoxManager/created", "BOXマスターの取得に失敗しました。("+error+")")
                    })
                })
            })
        },
    }
</script>
